import { Rule } from '@core/models/attendance/rule';
import { ApiKey } from '@core/models/settings/api-key';
import { BillingInvoice } from '@core/models/billing/billing-invoice';
import { Board } from '@core/models/board/board';
import { Connection } from '@core/models/connection/connection';
import { ConnectionPermission } from '@core/models/connection/connection-permission';
import { DeliveryOrder } from '@core/models/delivery/delivery-order';
import { DeliveryOrderConfig } from '@core/models/delivery/delivery-order-config';
import { DispatchConfig } from '@core/models/delivery/dispatch/dispatch-config';
import { Location } from '@core/models/location/location';
import { User } from '@core/models/user/user';

export interface IEntitiesState {
    entities: {
        board: { [id: string]: Board };
        connection: { [id: string]: Connection };
        connectionPermission: { [id: string]: ConnectionPermission };
        dispatchConfig: { [id: string]: DispatchConfig };
        invoice: { [id: string]: BillingInvoice }
        location: { [id: string]: Location };
        locationRule: { [id: string]: Rule };

        deliveryOrder: { [id: string]: DeliveryOrder };
        deliveryOrderConfig: { [id: string]: DeliveryOrderConfig };

        user: { [id: string]: User };
        driver: { [id: string]: User };
        apiKey: { [id: string]: ApiKey };

        reportDeliveriesByDriver: { [id: string]: any }
    };
    relationships: {
        connectionCertifications: { [id: string]: string[] };
        connectionDSTExclusions: { [id: string]: string[] };
        connectionPermissions: { [id: string]: string[] };
    };
}

export function initialEntitiesState(): IEntitiesState {
    return {
        entities: {
            board: {},
            
            connection: {},
            connectionPermission: {},
            
            dispatchConfig: {},

            invoice: {},
            location: {},
            locationRule: {},
            
            deliveryOrder: {},
            deliveryOrderConfig: {},

            user: {},
            driver: {},
            apiKey: {},

            reportDeliveriesByDriver: {}
        },
        relationships: {
            connectionCertifications: {},
            connectionDSTExclusions: {},
            connectionPermissions: {},
        },
    };
}